const unidades = ['', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove',
  'dez', 'onze', 'doze', 'treze', 'quatorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove']
const dezenas = ['', '', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa']
const centenas = ['', 'cento', 'duzentos', 'trezentos', 'quatrocentos', 'quinhentos',
  'seiscentos', 'setecentos', 'oitocentos', 'novecentos']

function ext100(n) {
  if (n === 100) return 'cem'
  const c = Math.floor(n / 100)
  const resto = n % 100
  const d = Math.floor(resto / 10)
  const u = resto % 10
  const partes = []
  if (c) partes.push(centenas[c])
  if (resto < 20) { if (resto) partes.push(unidades[resto]) }
  else {
    if (d) partes.push(dezenas[d])
    if (u) partes.push(unidades[u])
  }
  return partes.join(' e ')
}

export function valorPorExtenso(valor) {
  const v = Math.round(parseFloat(valor) * 100)
  if (isNaN(v) || v <= 0) return ''
  const reais = Math.floor(v / 100)
  const centavos = v % 100
  const partes = []
  if (reais > 0) {
    const s = reais === 1 ? 'real' : 'reais'
    if (reais < 1000) partes.push(`${ext100(reais)} ${s}`)
    else {
      const mil = Math.floor(reais / 1000)
      const resto = reais % 1000
      let txt = mil === 1 ? 'mil' : `${ext100(mil)} mil`
      if (resto) txt += ` e ${ext100(resto)}`
      partes.push(`${txt} ${s}`)
    }
  }
  if (centavos > 0) {
    const s = centavos === 1 ? 'centavo' : 'centavos'
    partes.push(`${unidades[centavos] || ext100(centavos)} ${s}`)
  }
  return partes.join(' e ')
}

export function formatarMoeda(valor) {
  return parseFloat(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function formatarData(dataISO) {
  if (!dataISO) return ''
  const [ano, mes, dia] = dataISO.split('-')
  return `${dia}/${mes}/${ano}`
}

export function dataHoje() {
  return new Date().toISOString().split('T')[0]
}
